"use client";
import { Box, IconButton } from "@chakra-ui/react";
import { useState } from "react";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { BannerCarouselProps } from "../../../@types/Carousel";
import Image from "../../Image";
import "./styles/BannerCarousel_1.css";

function BannerCarousel_1({ swiperConfig, bannerItems }: BannerCarouselProps) {
  const [nextEl, setNextEl] = useState<HTMLButtonElement | null>(null);
  const [prevEl, setPrevEl] = useState<HTMLButtonElement | null>(null);
  const iconButtonProps = {
    variant: "unstyled",
    fontSize: "2rem",
    color: "white",
    top: "50%",
    zIndex: 100,

    sx: {
      transform: "translateY(-50%)",
    },
    _hover: {
      color: "primary.500",
    },
  };

  return (
    <Box position="relative">
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        modules={[Navigation]}
        {...swiperConfig}
        navigation={{
          enabled: true,
          prevEl,
          nextEl,
        }}
      >
        {bannerItems?.map((item, index) => (
          <SwiperSlide key={`banner_slide_${index}`}>
            <Box w="full" h="40rem">
              <Image
                objectFit="cover"
                w="full"
                h="full"
                objectPosition="center"
                src={item.bannerImg}
                alt={`banner_slide_${index}`}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
      <IconButton
        position="absolute"
        aria-label="prevElement"
        left="1rem"
        ref={(el) => setPrevEl(el as HTMLButtonElement)}
        icon={<IoIosArrowDropleftCircle />}
        {...iconButtonProps}
      />
      <IconButton
        aria-label="nextElement"
        ref={(el) => setNextEl(el as HTMLButtonElement)}
        position="absolute"
        right="1rem"
        icon={<IoIosArrowDroprightCircle />}
        {...iconButtonProps}
      />
    </Box>
  );
}

export default BannerCarousel_1;
